import { Action, createAction, handleActions } from "redux-actions";
import { Services } from "~api/services";
import { GetTiposCoberturaResponse, TipoCobertura } from "~api/types";

interface GetTiposCoberturasCompletedPayload {
  tiposCobertura: TipoCobertura[];
}

interface TiposCoberturaState {
  failed: boolean;
  isLoading: boolean;
  tiposCobertura: TipoCobertura[];
}

const getTiposCoberturasInited = createAction(
  "OBTENER_TIPOS_COBERTURAS_INITED"
);

const getTiposCoberturasCompleted = createAction(
  "OBTENER_TIPOS_COBERTURAS_COMPLETED",
  (
    response: GetTiposCoberturaResponse | null | undefined
  ): GetTiposCoberturasCompletedPayload => {
    let tiposCobertura: TipoCobertura[] = [];

    // El chequeo de `length` cubre una respuesta vacía que no respete el
    // contrato (un array o un texto vacío): en ese caso se conserva la lista
    // vacía en lugar de leer una propiedad inexistente.
    if (
      typeof response !== "undefined" &&
      response !== null &&
      (response as { length?: number }).length !== 0
    ) {
      tiposCobertura = response.tipoCobertura;
    }

    return { tiposCobertura };
  }
);
const getTiposCoberturasFailed = createAction(
  "OBTENER_TIPOS_COBERTURAS_FAILED",
  (error: unknown) => ({ error })
);

const getTiposCobertura = () => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getTiposCoberturasInited());

      const response = await services.api.tiposCobertura().getTiposCobertura();

      dispatch(getTiposCoberturasCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getTiposCoberturasFailed(error));
    }
  };
};

const tiposCoberturaInitialState: TiposCoberturaState = {
  failed: false,
  isLoading: false,
  tiposCobertura: [],
};

const tipoCoberturaReducer = handleActions<TiposCoberturaState, any>(
  {
    [getTiposCoberturasInited.toString()]: (
      state: TiposCoberturaState
    ): TiposCoberturaState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getTiposCoberturasCompleted.toString()]: (
      state: TiposCoberturaState,
      action: Action<GetTiposCoberturasCompletedPayload>
    ): TiposCoberturaState => {
      return {
        ...state,
        tiposCobertura: action.payload.tiposCobertura,
        isLoading: false,
        failed: false,
      };
    },
    [getTiposCoberturasFailed.toString()]: (
      state: TiposCoberturaState
    ): TiposCoberturaState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
  },
  tiposCoberturaInitialState
);

export { tipoCoberturaReducer };
export { getTiposCobertura };
